import { useDispatch } from "@/redux";
import meActions from "@/redux/me/actions";

export const useAccountDispatch = () => {
  const dispatch = useDispatch();
  return { dispatch, ...meActions };
};
